import { Injectable } from "@angular/core";
import { ActivatedRouteSnapshot, Router, Route } from "@angular/router";
import { AuthenticationService } from "../shared/services/authentication.service";
import { Observable, of as observableOf } from "rxjs";
import { catchError } from "rxjs/operators";

@Injectable()
export class RoleGuard  {
  constructor(public authService: AuthenticationService, public router: Router) {}

  canActivate(route: ActivatedRouteSnapshot): Observable<any> {
    return this.authService.hasRoles(route.data["roles"]).pipe(
      catchError(() => {
        this.router.navigate(["errors/403"]);
        return observableOf(false);
      })
    );
  }

  canActivateChild(route: ActivatedRouteSnapshot): Observable<any> {
    return this.canActivate(route);
  }

  canLoad(route: Route): Observable<any> {
    return this.canActivate(route as ActivatedRouteSnapshot);
  }
}
